import { TableCell, TableRow } from '@mui/material';
import { Box } from './Box';
import { ICurrentCalculationSession } from '../../redux/Calculations/CurrentCalculationSessionInterface';

// Get the column names from first row of table data
export const getKeys = (record: any) => {
  return Object.keys(record);
};

// Render a single row of the table
const RenderRow = (props: any) => {
  return props.keys.map((key: string, index: number) => {
    // Convert boolean values to "True" or "False"
    const value =
      typeof props.data[key] === 'boolean' ? (props.data[key] ? 'True' : 'False') : props.data[key];
    return <TableCell key={`${index}_${key}`}>{value}</TableCell>;
  });
};

// Get all rows data and pass it to RenderRow to display table data
export const getRowsData = (
  SampleRecords: Array<Record<string, any>>,
  savedCalculations: ICurrentCalculationSession[],
) => {
  if (SampleRecords && SampleRecords.length > 0) {
    let keys = getKeys(SampleRecords[0]);
    keys = keys.sort((a, b) => {
      // check if a is a saved calculation if so return -1
      const isASaved = savedCalculations?.find(
        (calc) =>
          calc.calculationInfo.calculatedFieldName?.toLowerCase().replace(/[^a-z0-9]/g, '') ===
            a.toLowerCase().replace(/[^a-z0-9]/g, '') && !calc.isAggregated,
      )
        ? true
        : false;
      const isBSaved = savedCalculations?.find(
        (calc) =>
          calc.calculationInfo.calculatedFieldName?.toLowerCase().replace(/[^a-z0-9]/g, '') ===
            b.toLowerCase().replace(/[^a-z0-9]/g, '') && !calc.isAggregated,
      )
        ? true
        : false;

      if (isASaved && !isBSaved) return 1;
      if (!isASaved && isBSaved) return -1;
      return 0;
    });

    return SampleRecords.map((row, index: number) => {
      return (
        <TableRow
          sx={{
            '& .MuiTableCell-root': {
              borderBottom: '0px',
            },
          }}
          key={index}
        >
          <RenderRow key={index} data={row} keys={keys} />
        </TableRow>
      );
    });
  } else return null;
};

export const RenderButtons = ({
  SampleRecords,
  columnsData,
  savedCalculations,
}: {
  SampleRecords: Array<Record<string, any>>;
  columnsData: any[];
  savedCalculations: ICurrentCalculationSession[];
}) => {
  if (SampleRecords && SampleRecords.length > 0) {
    var keys = getKeys(SampleRecords[0]);
    keys = keys.sort((a, b) => {
      const isASaved = savedCalculations?.find(
        (calc) =>
          calc.calculationInfo.calculatedFieldName?.toLowerCase().replace(/[^a-z0-9]/g, '') ===
          a.toLowerCase().replace(/[^a-z0-9]/g, ''),
      )
        ? true
        : false;
      const isBSaved = savedCalculations?.find(
        (calc) =>
          calc.calculationInfo.calculatedFieldName?.toLowerCase().replace(/[^a-z0-9]/g, '') ===
          b.toLowerCase().replace(/[^a-z0-9]/g, ''),
      )
        ? true
        : false;

      if (isASaved && !isBSaved) return 1;
      if (!isASaved && isBSaved) return -1;
      return 0;
    });
    return keys.map((key: string, index: number) => {
      return (
        <button
          key={key}
          className="boxContainer"
          draggable="true"
          // onDragStart={(e) => handleDragStart(e, columnsData[index])}
        >
          <Box name={key} type="card" fieldData={columnsData[index]} colsOnly={true} />
        </button>
      );
    });
  } else
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p>No records are available for this table</p>
      </div>
    );
};
